import axios from 'axios';
import { MAIN_URL } from '../Configurations/Urls';
import toast from 'react-hot-toast';

export async function fetchApplicationUserRoles() {
  try {
    const response = await axios.get(`${MAIN_URL}/api/application/userrole`);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      toast.error("Session Expired!");
      window.location.href = "/login";
    }

    if (error.response) {
      console.error('API Response Error:', error.response.data);
      throw new Error(error.response.data.error || 'Failed to fetch Application user roles');
    } else if (error.request) {
      console.error('No Response Received:', error.request);
      throw new Error('No response from server.');
    } else {
      console.error('Error:', error.message);
      throw new Error('An unexpected error occurred.');
    }
  }
}

export function normalizeOrganizationUserRoles(payload) {
  const list = Array.isArray(payload)
    ? payload
    : Array.isArray(payload?.userroles)
    ? payload.userroles
    : Array.isArray(payload?.data)
    ? payload.data
    : [];

  return list
    .map((role) => {
      const organizationUserRoleId =
        role.organization_user_role_id ?? role.id ?? null;

      return {
        organization_user_role_id:
          organizationUserRoleId != null ? String(organizationUserRoleId) : '',
        user_role_name:
          role.user_role_name || role.role_name || role.name || '',
        role_name: role.role_name || role.user_role_name || role.name || '',
      };
    })
    .filter((role) => role.organization_user_role_id);
}

export async function fetchOrganizationUserRoles(organizationId, { mode } = {}) {
  if (!organizationId) {
    throw new Error('Organization id is required.');
  }

  try {
    const params = mode != null ? { mode: String(mode) } : {};
    const response = await axios.get(
      `${MAIN_URL}/api/organizations/${organizationId}/userrole`,
      { params }
    );
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      toast.error("Session Expired!");
      window.location.href = "/login";
    }

    if (error.response) {
      throw new Error(
        error.response.data?.error ||
          error.response.data?.message ||
          'Failed to fetch organization user roles'
      );
    }

    throw new Error('An unexpected error occurred.');
  }
}

/** Roles for dropdowns (organization_user_roles); falls back if compact list is empty. */
export async function fetchOrganizationUserRolesForSelect(organizationId) {
  const compact = await fetchOrganizationUserRoles(organizationId, { mode: 1 });
  let roles = normalizeOrganizationUserRoles(compact);

  if (roles.length === 0) {
    const full = await fetchOrganizationUserRoles(organizationId);
    roles = normalizeOrganizationUserRoles(full);
  }

  if (roles.length === 0) {
    const response = await axios.post(
      `${MAIN_URL}/api/organizations/${organizationId}/userroles-filtered`,
      {
        filters: [],
        page: 1,
        pageSize: 500,
        sort: { field: 'role_name', direction: 'asc' },
      }
    );
    if (response.data?.success && Array.isArray(response.data?.data)) {
      roles = normalizeOrganizationUserRoles(response.data.data);
    }
  }

  return roles;
}

export async function fetchApplicationUserModules() {
  try {
    const response = await axios.get(`${MAIN_URL}/api/application/module`
    );
    console.log("user module",response);
    return response.data;

  } catch (error) {

        if (error.response && error.response.status === 401) {
  toast.error("Session Expired!");
  window.location.href = "/login";
}


    if (error.response) {
      console.error('API Response Error:', error.response.data);
      throw new Error(error.response.data.error || 'Failed to fetch Application user module');
    } else if (error.request) {
      console.error('No Response Received:', error.request);
      throw new Error('No response from server.');
    } else {
      console.error('Error:', error.message);
      throw new Error('An unexpected error occurred.');
    }
  }
}


export async function fetchApplicationUserModuleAction() {
  try {
    const response = await axios.get(`${MAIN_URL}/api/application/module-action`
    );
    return response.data;
  } catch (error) {
        if (error.response && error.response.status === 401) {
  toast.error("Session Expired!");
  window.location.href = "/login";
}


    if (error.response) {
      console.error('API Response Error:', error.response.data);
      throw new Error(error.response.data.error || 'Failed to fetch Application user module actions');
    } else if (error.request) {
      console.error('No Response Received:', error.request);
      throw new Error('No response from server.');
    } else {
      console.error('Error:', error.message);
      throw new Error('An unexpected error occurred.');
    }
  }
}


export async function fetchApplicationUser() {
  try {
    const response = await axios.get(`${MAIN_URL}/api/application/user`
    );
    return response.data;
  } catch (error) {
        if (error.response && error.response.status === 401) {
  toast.error("Session Expired!");
  window.location.href = "/login";
}


    if (error.response) {
      console.error('API Response Error:', error.response.data);
      throw new Error(error.response.data.error || 'Failed to fetch Application users');
    } else if (error.request) {
      console.error('No Response Received:', error.request);
      throw new Error('No response from server.');
    } else {
      console.error('Error:', error.message);
      throw new Error('An unexpected error occurred.');
    }
  }
}




export async function fetchApplicationUserBtId(Org_id) {
  try {
    const response = await axios.get(`${MAIN_URL}/api/application/user`,{
      organization_id:Org_id
    }
    );
    return response.data;
  } catch (error) {
        if (error.response && error.response.status === 401) {
  toast.error("Session Expired!");
  window.location.href = "/login";
}


    if (error.response) {
      console.error('API Response Error:', error.response.data);
      throw new Error(error.response.data.error || 'Failed to fetch Application users');
    } else if (error.request) {
      console.error('No Response Received:', error.request);
      throw new Error('No response from server.');
    } else {
      console.error('Error:', error.message);
      throw new Error('An unexpected error occurred.');
    }
  }
}



export async function fetchApplicationUserErrorLogs() {
  try {
    const response = await axios.get(`${MAIN_URL}/api/application/error-logs`
    );
    console.log("errors data ",response.data);
    return response.data;
  } catch (error) {

        if (error.response && error.response.status === 401) {
  toast.error("Session Expired!");
  window.location.href = "/login";
}



    if (error.response) {
      console.error('API Response Error:', error.response.data);
      throw new Error(error.response.data.error || 'Failed to fetch Application user module actions');
    } else if (error.request) {
      console.error('No Response Received:', error.request);
      throw new Error('No response from server.');
    } else {
      console.error('Error:', error.message);
      throw new Error('An unexpected error occurred.');
    }
  }
}


export async function fetchApplicationRoleAssignment() {
  try {
    const response = await axios.get(`${MAIN_URL}/api/application/userrole-assignment`
    );

    console.log("ALL DATA IS  ",response.data)
    return response.data;
  } catch (error) {

        if (error.response && error.response.status === 401) {
  toast.error("Session Expired!");
  window.location.href = "/login";
}




    if (error.response) {
      console.error('API Response Error:', error.response.data);
      throw new Error(error.response.data.error || 'Failed to fetch Application user rolw assignment');
    } else if (error.request) {
      console.error('No Response Received:', error.request);
      throw new Error('No response from server.');
    } else {
      console.error('Error:', error.message);
      throw new Error('An unexpected error occurred.');
    }
  }
}


export async function fetchApplicationPermission() {
  try {
    const response = await axios.get(`${MAIN_URL}/api/application/user-permission`
    );

    console.log(response.data)
    return response.data;
  } catch (error) {

        if (error.response && error.response.status === 401) {
  toast.error("Session Expired!");
  window.location.href = "/login";
}




    if (error.response) {
      console.error('API Response Error:', error.response.data);
      throw new Error(error.response.data.error || 'Failed to fetch Application user rolw assignment');
    } else if (error.request) {
      console.error('No Response Received:', error.request);
      throw new Error('No response from server.');
    } else {
      console.error('Error:', error.message);
      throw new Error('An unexpected error occurred.');
    }
  }
}


export const fetchOrganizationRolePermissions = async (organizationId) => {
  if (!organizationId) {
    throw new Error('Organization id is required.');
  }

  try {
    const response = await axios.get(
      `${MAIN_URL}/api/organizations/${organizationId}/role-permissions`
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching organization role permissions:', error);
    throw error;
  }
};

export const fetchOrganizationRolePermissionsByRole = async (
  organizationId,
  organizationUserRoleId
) => {
  if (!organizationId || !organizationUserRoleId) {
    throw new Error('Organization id and organization role id are required.');
  }

  try {
    const response = await axios.get(
      `${MAIN_URL}/api/organizations/${organizationId}/role-permissions/particular/${organizationUserRoleId}`
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching organization role permissions by role:', error);
    throw error;
  }
};

export const saveOrganizationRolePermissions = async (organizationId, payload) => {
  if (!organizationId) {
    throw new Error('Organization id is required.');
  }

  try {
    const response = await axios.post(
      `${MAIN_URL}/api/organizations/${organizationId}/role-permissions`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error('Error saving organization role permissions:', error);
    throw error;
  }
};

export const deleteOrganizationRolePermissions = async (
  organizationId,
  organizationUserRoleId
) => {
  if (!organizationId || !organizationUserRoleId) {
    throw new Error('Organization id and organization role id are required.');
  }

  try {
    const response = await axios.delete(
      `${MAIN_URL}/api/organizations/${organizationId}/role-permissions/particular/${organizationUserRoleId}`
    );
    return response.data;
  } catch (error) {
    console.error('Error deleting organization role permissions:', error);
    throw error;
  }
};

/** @deprecated Use fetchOrganizationRolePermissions for org apps (HR/EMS/PM). */
export const fetchApplicationRolePermission = fetchOrganizationRolePermissions;







export const fetchUserEffectivePermissions = async (
  organizationId,
  applicationUserId
) => {
  if (!organizationId || !applicationUserId) {
    throw new Error('Organization id and application user id are required.');
  }

  const response = await axios.get(
    `${MAIN_URL}/api/application/user-permissions/particularss/${applicationUserId}`,
    {
      params: {
        organization_id: organizationId,
      },
    }
  );

  return response.data;
};

export async function fetchApplicationUserPermission(Org_id) {
  try {
    const response = await axios.get(`${MAIN_URL}/api/application/user-permissions`,
      {
    params: {
      organization_id: Org_id,
    },
  }
    );

    console.log(response.data)
    return response.data;
  } catch (error) {
        if (error.response && error.response.status === 401) {
  toast.error("Session Expired!");
  window.location.href = "/login";
}


    if (error.response) {
      console.error('API Response Error:', error.response.data);
      throw new Error(error.response.data.error || 'Failed to fetch Application user rolw assignment');
    } else if (error.request) {
      console.error('No Response Received:', error.request);
      throw new Error('No response from server.');
    } else {
      console.error('Error:', error.message);
      throw new Error('An unexpected error occurred.');
    }
  }
}

